import React, { createContext, useContext, useState, ReactNode } from 'react';
export type Language = 'ES' | 'EN';
interface ProjectText {
  category: string;
  title: string;
  description: string;
}
interface Translation {
  // Nav
  nav_sub: string;
  nav_portfolio: string;
  nav_services: string;
  nav_philosophy: string;
  nav_consult: string;
  nav_cta: string;
  nav_lang_label: string;
  // Hero
  hero_badge: string;
  hero_h1_line1: string;
  hero_h1_line2: string;
  hero_h1_line3_gradient: string;
  hero_h1_rest: string;
  hero_h1_line4: string;
  hero_sub: string;
  hero_cta1: string;
  hero_cta2: string;
  // Stats
  stats_label1: string;
  stats_label2: string;
  stats_label3: string;
  stats_label4: string;
  // Marquee
  marquee_items: string[];
  // Services header
  services_label: string;
  services_heading: string;
  services_intro: string;
  // Website card
  web_tag: string;
  web_title: string;
  web_description: string;
  web_process1: string;
  web_process2: string;
  web_process3: string;
  web_result1_num: string;
  web_result1_label: string;
  web_result2_num: string;
  web_result2_label: string;
  web_result3_num: string;
  web_result3_label: string;
  web_promise: string;
  web_levels_label: string;
  web_pill1: string;
  web_pill2: string;
  web_pill3: string;
  web_pricing_note: string;
  web_cta: string;
  // Meta ads card
  ads_tag: string;
  ads_title: string;
  ads_description: string;
  ads_row1_title: string;
  ads_row1_sub: string;
  ads_row2_title: string;
  ads_row2_sub: string;
  ads_row3_title: string;
  ads_row3_sub: string;
  ads_row4_title: string;
  ads_row4_sub: string;
  ads_funnel_caption: string;
  ads_do1: string;
  ads_do2: string;
  ads_do3: string;
  ads_do4: string;
  ads_promise: string;
  ads_cta: string;
  // CRM card
  crm_tag: string;
  crm_title: string;
  crm_description: string;
  crm_stage1: string;
  crm_stage2: string;
  crm_stage3: string;
  crm_stage4: string;
  crm_problem_label: string;
  crm_problem_text: string;
  crm_solution_label: string;
  crm_solution_text: string;
  crm_included1: string;
  crm_included2: string;
  crm_included3: string;
  crm_included4: string;
  crm_included5: string;
  crm_included6: string;
  crm_promise: string;
  crm_cta: string;
  // Growth banner
  growth_label: string;
  growth_heading: string;
  growth_body: string;
  growth_diff1: string;
  growth_diff2: string;
  growth_diff3: string;
  growth_diff4: string;
  growth_cta: string;
  // Portfolio
  portfolio_label: string;
  portfolio_heading: string;
  portfolio_intro: string;
  portfolio_cta: string;
  portfolio_case: string;
  modal_open_new_tab: string;
  modal_fallback: string;
  projects: ProjectText[];
  // Philosophy
  philosophy_label: string;
  philosophy_heading: string;
  philosophy_p1: string;
  philosophy_p2: string;
  philosophy_principles: string[];
  // Consulta
  consulta_label: string;
  consulta_heading: string;
  consulta_sub: string;
  field1_label: string;
  field1_placeholder: string;
  field2_label: string;
  field2_placeholder: string;
  field3_label: string;
  field3_placeholder: string;
  field4_label: string;
  field4_placeholder: string;
  field5_label: string;
  field5_placeholder: string;
  consulta_submit: string;
  consulta_success: string;
  whatsapp_label: string;
  whatsapp_heading: string;
  whatsapp_body: string;
  whatsapp_cta: string;
  // Footer
  footer_top_label: string;
  footer_tagline: string;
  footer_nav_label: string;
  footer_direct_label: string;
  footer_email: string;
  footer_rights: string;
  footer_appointment: string;
  footer_crafted: string;
}
const translations: Record<Language, Translation> = {
  ES: {
    nav_sub: 'Estudio Digital Orientado a Resultados',
    nav_portfolio: 'PORTAFOLIO',
    nav_services: 'SERVICIOS',
    nav_philosophy: 'FILOSOFÍA',
    nav_consult: 'CONSULTA',
    nav_cta: 'INICIAR PROYECTO →',
    nav_lang_label: 'Cambiar idioma',
    hero_badge: 'GROWTH PARTNER & ESTUDIO DIGITAL — 2025',
    hero_h1_line1: 'Crecimiento digital',
    hero_h1_line2: 'a medida,',
    hero_h1_line3_gradient: 'creados',
    hero_h1_rest: 'para',
    hero_h1_line4: 'marcas distinguidas.',
    hero_sub: 'Somos tu Growth Partner. Diseñamos sitios web de alto impacto, activamos campañas en Meta Ads y gestionamos tu CRM para convertir cada lead en cliente.',
    hero_cta1: 'VER PORTAFOLIO →',
    hero_cta2: 'WHATSAPP PRIVADO →',
    stats_label1: 'COMISIONES',
    stats_label2: 'INDUSTRIAS',
    stats_label3: 'HECHO A MEDIDA',
    stats_label4: 'PIXEL-PERFECT',
    marquee_items: ['Diseño Editorial', 'Oficio Bilingüe', 'Arquitectura de Conversión', 'Meta Ads', 'Captación de Leads', 'CRM & Automatización', 'Growth Partner', 'Mobile-First', 'Rendimiento', 'Por Cita', 'Sitios a Medida', 'ROI Medible'],
    services_label: 'SERVICIOS',
    services_heading: 'Todo lo que tu marca necesita para crecer.',
    services_intro: 'Somos tu equipo de crecimiento digital completo. Desde la primera impresión hasta el cierre de venta — lo construimos, lo activamos y lo medimos.',
    web_tag: 'DISEÑO & DESARROLLO',
    web_title: 'Sitios Web a Medida',
    web_description: 'Construimos sitios que trabajan mientras tú duermes. Cada página está diseñada para guiar al visitante hacia una sola acción: contactarte.',
    web_process1: 'Diseño Editorial',
    web_process2: 'Desarrollo a Medida',
    web_process3: 'Lanzamiento & SEO',
    web_result1_num: '3x',
    web_result1_label: 'más conversiones',
    web_result2_num: '-60%',
    web_result2_label: 'menos rebote',
    web_result3_num: '100%',
    web_result3_label: 'mobile-first',
    web_promise: 'Sin promesas vacías — si no creemos que podemos ayudarte, te lo decimos antes de cobrar un euro.',
    web_levels_label: 'TRES NIVELES DE ALCANCE',
    web_pill1: 'ESENCIAL',
    web_pill2: 'PROFESIONAL',
    web_pill3: 'PREMIUM',
    web_pricing_note: 'Precios y detalles en consulta privada.',
    web_cta: 'EXPLORAR OPCIONES WEB →',
    ads_tag: 'PAID MEDIA',
    ads_title: 'Campañas Meta Ads',
    ads_description: 'Diseñamos, lanzamos y optimizamos campañas de captación en Facebook e Instagram. Cada euro invertido tiene un objetivo: traerte leads calificados.',
    ads_row1_title: 'AUDIENCIA',
    ads_row1_sub: 'Miles de personas',
    ads_row2_title: 'IMPACTO',
    ads_row2_sub: 'Ven tu anuncio',
    ads_row3_title: 'INTERÉS',
    ads_row3_sub: 'Hacen clic',
    ads_row4_title: 'LEAD',
    ads_row4_sub: 'Contactan',
    ads_funnel_caption: 'Así funciona la captación. Lo gestionamos completo.',
    ads_do1: 'Creamos los anuncios y los creativos visuales',
    ads_do2: 'Segmentamos la audiencia ideal para tu negocio',
    ads_do3: 'Optimizamos diario para bajar el coste por lead',
    ads_do4: 'Reporte claro cada semana — sin tecnicismos',
    ads_promise: 'No garantizamos leads mágicos. Garantizamos un proceso profesional, transparente y optimizado.',
    ads_cta: 'ACTIVAR CAMPAÑA →',
    crm_tag: 'GROWTH PARTNER',
    crm_title: 'CRM & Automatización',
    crm_description: 'Implementamos y gestionamos tu CRM para que ningún lead se pierda. Automatizamos el seguimiento, la nutrición y el cierre.',
    crm_stage1: 'LEAD ENTRA',
    crm_stage2: 'CLASIFICADO',
    crm_stage3: 'NUTRIDO',
    crm_stage4: 'CERRADO',
    crm_problem_label: 'EL PROBLEMA',
    crm_problem_text: 'El 70% de los leads no reciben seguimiento a tiempo y se enfrían. Tu CRM lo soluciona.',
    crm_solution_label: 'LA SOLUCIÓN',
    crm_solution_text: 'Cada lead queda registrado, clasificado y con un seguimiento automático activado — en minutos, no en días.',
    crm_included1: 'Implementación CRM',
    crm_included2: 'Pipelines personalizados',
    crm_included3: 'Automatización emails/WA',
    crm_included4: 'Seguimiento en tiempo real',
    crm_included5: 'Reportes mensuales',
    crm_included6: 'Soporte 1:1 continuo',
    crm_promise: 'El CRM no cierra ventas solo — te da la estructura para que tú puedas cerrarlas más rápido y mejor.',
    crm_cta: 'IMPLEMENTAR MI CRM →',
    growth_label: 'POR QUÉ ELEGIRNOS',
    growth_heading: 'No somos una agencia. Somos tu equipo.',
    growth_body: 'La mayoría de agencias te asigna un ejecutivo de cuenta que subcontrata tu trabajo. Nosotros operamos diferente: contacto directo, ejecución propia, resultados medibles.',
    growth_diff1: 'Contacto directo — sin intermediarios',
    growth_diff2: 'Respuesta en menos de 24 horas',
    growth_diff3: 'Foco en ROI — no en métricas de vanidad',
    growth_diff4: 'Un cliente por industria — exclusividad total',
    growth_cta: 'AGENDAR UNA LLAMADA →',
    portfolio_label: 'EL PORTAFOLIO',
    portfolio_heading: 'Una selección de comisiones recientes.',
    portfolio_intro: 'Cada proyecto a continuación fue construido a mano, de principio a fin. Pasa el cursor para ver el detalle; selecciona uno para entrar en la experiencia en vivo.',
    portfolio_cta: 'ENTRAR A LA EXPERIENCIA →',
    portfolio_case: 'CASO',
    modal_open_new_tab: 'ABRIR EN NUEVA PESTAÑA →',
    modal_fallback: 'Vista previa no disponible — haz clic en el enlace para abrir',
    projects: [{
      category: 'TECHOS RESIDENCIALES',
      title: 'El Maestro del Oficio',
      description: 'Una experiencia de captación autoritativa para un contratista de techos premium — diseñada para inspirar confianza antes de la primera llamada.'
    }, {
      category: 'BIENES RAÍCES',
      title: 'La Dirección Exclusiva',
      description: 'Una plataforma refinada de búsqueda de propiedades que antepone la arquitectura y el estilo de vida a los listados.'
    }, {
      category: 'SERVICIOS DE CLIMA',
      title: 'El Estándar de Emergencia',
      description: 'Un sitio de servicio 24/7 diseñado para el momento preciso en que un cliente necesita ayuda.'
    }, {
      category: 'BIENESTAR',
      title: 'El Santuario',
      description: 'Una experiencia de reservas inmersiva para un destino de bienestar de alta gama — calmada, considerada, cinematográfica.'
    }, {
      category: 'PLOMERÍA',
      title: 'La Mano Confiable',
      description: 'Un sitio de plomería bilingüe optimizado para descubrimiento local y conversión de emergencias.'
    }, {
      category: 'ASESORÍA LEGAL',
      title: 'El Consejo de Confianza',
      description: 'Un sitio de práctica legal autoritativo que convierte investigación en consultas.'
    }, {
      category: 'FITNESS',
      title: 'El Atelier de la Fuerza',
      description: 'Una experiencia editorial y audaz para una marca de fitness moderna — hecha para la ambición.'
    }, {
      category: 'VETERINARIA',
      title: 'La Clínica Familiar',
      description: 'Una experiencia cálida y refinada para una clínica veterinaria familiar — confianza expresada con sobriedad.'
    }, {
      category: 'BIENES RAÍCES DE LUJO',
      title: 'La Colección Privada',
      description: 'Un showcase cinematográfico para propiedades trofeo — diseñado para calificar, no solo para listar.'
    }],
    philosophy_label: 'FILOSOFÍA',
    philosophy_heading: 'El estándar es el trabajo mismo.',
    philosophy_p1: 'Operamos como un estudio uno-a-uno para marcas de servicios en EE.UU. y Latinoamérica — discreto, bilingüe y silenciosamente obsesionado con el oficio. Sin plantillas, sin capas de agencia; solo colaboración directa entre tú y la persona que construye tu presencia digital y activa tu crecimiento.',
    philosophy_p2: 'Cada comisión comienza con la misma pregunta: ¿qué merece sentir esta marca? La respuesta da forma a cada píxel, cada palabra, cada campaña — y en última instancia, a cada conversión.',
    philosophy_principles: ['Sitios a Medida', 'Páginas de Conversión', 'Meta Ads & Captación', 'CRM & Automatización', 'Oficio Bilingüe', 'Mobile-First & SEO', 'Arquitectura de Conversión', 'Rendimiento Editorial'],
    consulta_label: 'CONSULTA',
    consulta_heading: 'Inicia una conversación privada.',
    consulta_sub: 'Cuéntame sobre la marca y el trabajo por venir. Cada consulta recibe una respuesta personal en menos de un día hábil.',
    field1_label: 'NOMBRE COMPLETO',
    field1_placeholder: 'Tu nombre',
    field2_label: 'CORREO',
    field2_placeholder: 'tu@marca.com',
    field3_label: 'TELÉFONO',
    field3_placeholder: 'Opcional',
    field4_label: 'TIPO DE PROYECTO',
    field4_placeholder: 'Web, Ads, CRM, todo lo anterior...',
    field5_label: 'BRIEF DEL PROYECTO',
    field5_placeholder: 'Algunas frases sobre la marca, la audiencia y el trabajo por venir.',
    consulta_submit: 'ENVIAR CONSULTA →',
    consulta_success: 'Gracias por escribir. Te responderemos en menos de un día hábil.',
    whatsapp_label: 'WHATSAPP',
    whatsapp_heading: 'Una línea más directa.',
    whatsapp_body: 'Para asuntos que avanzan rápido — WhatsApp está abierto.',
    whatsapp_cta: 'ABRIR WHATSAPP →',
    footer_top_label: 'Estudio Digital Orientado a Resultados',
    footer_tagline: 'Tu Growth Partner. Sitios web · Meta Ads · CRM.',
    footer_nav_label: 'NAVEGAR',
    footer_direct_label: 'DIRECTO',
    footer_email: 'Email',
    footer_rights: '© 2026 KINETIC GROWTH STUDIO. TODOS LOS DERECHOS RESERVADOS.',
    footer_appointment: '● POR CITA ÚNICAMENTE ●',
    footer_crafted: 'Website crafted by kineticgrowthstudio.com'
  },
  EN: {
    nav_sub: 'Results-Driven Digital Studio',
    nav_portfolio: 'PORTFOLIO',
    nav_services: 'SERVICES',
    nav_philosophy: 'PHILOSOPHY',
    nav_consult: 'CONSULT',
    nav_cta: 'START PROJECT →',
    nav_lang_label: 'Switch language',
    hero_badge: 'GROWTH PARTNER & DIGITAL STUDIO — 2025',
    hero_h1_line1: 'Digital growth',
    hero_h1_line2: 'built for you,',
    hero_h1_line3_gradient: 'crafted',
    hero_h1_rest: 'for',
    hero_h1_line4: 'distinguished brands.',
    hero_sub: 'We are your Growth Partner. We build high-impact websites, run Meta Ads campaigns and manage your CRM so every lead becomes a client.',
    hero_cta1: 'VIEW PORTFOLIO →',
    hero_cta2: 'PRIVATE WHATSAPP →',
    stats_label1: 'COMMISSIONS',
    stats_label2: 'INDUSTRIES',
    stats_label3: 'FULLY CUSTOM',
    stats_label4: 'PIXEL-PERFECT',
    marquee_items: ['Editorial Design', 'Bilingual Craft', 'Conversion Architecture', 'Meta Ads', 'Lead Capture', 'CRM & Automation', 'Growth Partner', 'Mobile-First', 'Performance', 'By Appointment', 'Custom Websites', 'Measurable ROI'],
    services_label: 'SERVICES',
    services_heading: 'Everything your brand needs to grow.',
    services_intro: "We're your complete digital growth team. From first impression to closed sale — we build it, activate it, and measure it.",
    web_tag: 'DESIGN & DEVELOPMENT',
    web_title: 'Custom Websites',
    web_description: "We build sites that work while you sleep. Every page is designed to guide the visitor toward a single action: contacting you.",
    web_process1: 'Editorial Design',
    web_process2: 'Custom Development',
    web_process3: 'Launch & SEO',
    web_result1_num: '3x',
    web_result1_label: 'more conversions',
    web_result2_num: '-60%',
    web_result2_label: 'less bounce',
    web_result3_num: '100%',
    web_result3_label: 'mobile-first',
    web_promise: "No empty promises — if we don't believe we can help you, we'll tell you before charging a single euro.",
    web_levels_label: 'THREE SCOPE LEVELS',
    web_pill1: 'ESSENTIAL',
    web_pill2: 'PROFESSIONAL',
    web_pill3: 'PREMIUM',
    web_pricing_note: 'Pricing and details in a private consultation.',
    web_cta: 'EXPLORE WEB OPTIONS →',
    ads_tag: 'PAID MEDIA',
    ads_title: 'Meta Ads Campaigns',
    ads_description: 'We design, launch and optimize lead-generation campaigns on Facebook and Instagram. Every euro invested has one goal: bringing you qualified leads.',
    ads_row1_title: 'AUDIENCE',
    ads_row1_sub: 'Thousands of people',
    ads_row2_title: 'IMPACT',
    ads_row2_sub: 'See your ad',
    ads_row3_title: 'INTEREST',
    ads_row3_sub: 'Click through',
    ads_row4_title: 'LEAD',
    ads_row4_sub: 'Reach out',
    ads_funnel_caption: "This is how lead capture works. We manage it end-to-end.",
    ads_do1: 'We create the ads and visual creatives',
    ads_do2: 'We target the ideal audience for your business',
    ads_do3: 'We optimize daily to lower cost per lead',
    ads_do4: 'Clear weekly report — no jargon',
    ads_promise: 'We don\u2019t guarantee magic leads. We guarantee a professional, transparent and optimized process.',
    ads_cta: 'LAUNCH CAMPAIGN →',
    crm_tag: 'GROWTH PARTNER',
    crm_title: 'CRM & Automation',
    crm_description: "We implement and manage your CRM so no lead gets lost. We automate follow-up, nurturing and closing.",
    crm_stage1: 'LEAD COMES IN',
    crm_stage2: 'QUALIFIED',
    crm_stage3: 'NURTURED',
    crm_stage4: 'CLOSED',
    crm_problem_label: 'THE PROBLEM',
    crm_problem_text: "70% of leads don't get followed up in time and go cold. Your CRM solves that.",
    crm_solution_label: 'THE SOLUTION',
    crm_solution_text: 'Every lead gets logged, qualified and set up with automatic follow-up — in minutes, not days.',
    crm_included1: 'CRM Implementation',
    crm_included2: 'Custom Pipelines',
    crm_included3: 'Email/WhatsApp Automation',
    crm_included4: 'Real-time Tracking',
    crm_included5: 'Monthly Reports',
    crm_included6: 'Ongoing 1:1 Support',
    crm_promise: "A CRM doesn't close sales by itself — it gives you the structure to close them faster and better.",
    crm_cta: 'IMPLEMENT MY CRM →',
    growth_label: 'WHY CHOOSE US',
    growth_heading: "We're not an agency. We're your team.",
    growth_body: 'Most agencies assign you an account manager who outsources your work. We operate differently: direct contact, in-house execution, measurable results.',
    growth_diff1: 'Direct contact — no middlemen',
    growth_diff2: 'Response in less than 24 hours',
    growth_diff3: 'Focus on ROI — not vanity metrics',
    growth_diff4: 'One client per industry — total exclusivity',
    growth_cta: 'SCHEDULE A CALL →',
    portfolio_label: 'THE PORTFOLIO',
    portfolio_heading: 'A selection of recent commissions.',
    portfolio_intro: 'Every project below was built by hand, start to finish. Hover to see the detail; select one to enter the live experience.',
    portfolio_cta: 'ENTER THE EXPERIENCE →',
    portfolio_case: 'CASE',
    modal_open_new_tab: 'OPEN IN NEW TAB →',
    modal_fallback: 'Preview not available — click the link to open',
    projects: [{
      category: 'RESIDENTIAL ROOFING',
      title: 'The Craft Master',
      description: 'An authoritative lead-capture experience for a premium roofing contractor — designed to inspire trust before the first call.'
    }, {
      category: 'REAL ESTATE',
      title: 'The Exclusive Address',
      description: 'A refined property search platform that puts architecture and lifestyle ahead of listings.'
    }, {
      category: 'CLIMATE SERVICES',
      title: 'The Emergency Standard',
      description: 'A 24/7 service site designed for the exact moment a customer needs help.'
    }, {
      category: 'WELLNESS',
      title: 'The Sanctuary',
      description: 'An immersive booking experience for a high-end wellness destination — calm, considered, cinematic.'
    }, {
      category: 'PLUMBING',
      title: 'The Reliable Hand',
      description: 'A bilingual plumbing site optimized for local discovery and emergency conversion.'
    }, {
      category: 'LEGAL COUNSEL',
      title: 'The Trusted Counsel',
      description: 'An authoritative legal practice site that turns research into consultations.'
    }, {
      category: 'FITNESS',
      title: 'The Strength Atelier',
      description: 'A bold, editorial experience for a modern fitness brand — built for ambition.'
    }, {
      category: 'VETERINARY',
      title: 'The Family Clinic',
      description: 'A warm, refined experience for a family veterinary clinic — trust expressed with restraint.'
    }, {
      category: 'LUXURY REAL ESTATE',
      title: 'The Private Collection',
      description: 'A cinematic showcase for trophy properties — designed to qualify, not just to list.'
    }],
    philosophy_label: 'PHILOSOPHY',
    philosophy_heading: 'The standard is the work itself.',
    philosophy_p1: "We operate as a one-to-one studio for service brands across the US and Latin America — discreet, bilingual, and quietly obsessed with craft. No templates, no agency layers; just direct collaboration between you and the person building your digital presence and driving your growth.",
    philosophy_p2: 'Every commission starts with the same question: what should this brand feel like? The answer shapes every pixel, every word, every campaign — and ultimately, every conversion.',
    philosophy_principles: ['Custom Websites', 'Conversion Pages', 'Meta Ads & Lead Gen', 'CRM & Automation', 'Bilingual Craft', 'Mobile-First & SEO', 'Conversion Architecture', 'Editorial Performance'],
    consulta_label: 'CONSULTATION',
    consulta_heading: 'Start a private conversation.',
    consulta_sub: 'Tell me about the brand and the work ahead. Every inquiry gets a personal reply within one business day.',
    field1_label: 'FULL NAME',
    field1_placeholder: 'Your name',
    field2_label: 'EMAIL',
    field2_placeholder: 'you@brand.com',
    field3_label: 'PHONE',
    field3_placeholder: 'Optional',
    field4_label: 'PROJECT TYPE',
    field4_placeholder: 'Web, Ads, CRM, all of the above...',
    field5_label: 'PROJECT BRIEF',
    field5_placeholder: 'A few sentences about the brand, the audience and the work ahead.',
    consulta_submit: 'SEND INQUIRY →',
    consulta_success: "Thanks for writing in. We'll reply within one business day.",
    whatsapp_label: 'WHATSAPP',
    whatsapp_heading: 'A more direct line.',
    whatsapp_body: "For things that move fast — WhatsApp is open.",
    whatsapp_cta: 'OPEN WHATSAPP →',
    footer_top_label: 'Results-Driven Digital Studio',
    footer_tagline: 'Your Growth Partner. Websites · Meta Ads · CRM.',
    footer_nav_label: 'NAVIGATE',
    footer_direct_label: 'DIRECT',
    footer_email: 'Email',
    footer_rights: '© 2026 KINETIC GROWTH STUDIO. ALL RIGHTS RESERVED.',
    footer_appointment: '● BY APPOINTMENT ONLY ●',
    footer_crafted: 'Website crafted by kineticgrowthstudio.com'
  }
};
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: Translation;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('ES');
  const t = translations[lang];
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-266" data-mp="3csadwm1co6f2">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}